module.exports = __webpack_public_path__ + "static/media/simulated.1c2c0614.png";